module.exports = __webpack_public_path__ + "static/media/logo.bf14b811.png";